import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        SharedModule,
        AppRoutingModule], providers: [provideHttpClient(withInterceptorsFromDi())] })

/**
 * dir-w | backOffice
 * Application modules
 *
 * Last update : January 11, 2024 | @rizkiprasetya
 */
export class AppModule {}
